(function () {
  var sizeMaps = {
    "US(M)": {
      XXS: "XXS",
      XS: "XS",
      S: "S",
      M: "M",
      L: "L",
      XL: "XL",
      "2XL": "2XL",
      XXL: "XXL",
      "3XL": "3XL",
      XXXL: "XXXL",
      "4XL": "4XL",
      XXXXL: "XXXXL",
      "5XL": "5XL",
      XXXXXL: "XXXXXL",
      "6XL": "6XL",
      XXXXXXL: "XXXXXXL"
    },
    "US(W)": {
      XXS: "XS",
      XS: "S",
      S: "M",
      M: "L",
      L: "XL",
      XL: "2XL",
      "2XL": "3XL",
      XXL: "3XL",
      "3XL": "4XL",
      XXXL: "4XL",
      "4XL": "5XL",
      XXXXL: "5XL",
      "5XL": "6XL",
      XXXXXL: "6XL",
      "6XL": "7XL",
      XXXXXXL: "7XL"
    },
    EU: {
      XXS: "42",
      XS: "44",
      S: "46",
      M: "48",
      L: "50",
      XL: "52",
      "2XL": "54",
      XXL: "54",
      "3XL": "56",
      XXXL: "56",
      "4XL": "58",
      XXXXL: "58",
      "5XL": "60",
      XXXXXL: "60",
      "6XL": "62",
      XXXXXXL: "62"
    },
    UK: {
      XXS: "XXS",
      XS: "XS",
      S: "S",
      M: "M",
      L: "L",
      XL: "XL",
      "2XL": "2XL",
      XXL: "XXL",
      "3XL": "3XL",
      XXXL: "XXXL",
      "4XL": "4XL",
      XXXXL: "XXXXL",
      "5XL": "5XL",
      XXXXXL: "XXXXXL",
      "6XL": "6XL",
      XXXXXXL: "XXXXXXL"
    }
  };

  function normalizeSize(size) {
    return String(size || "").trim().toUpperCase().replace(/\s+/g, "");
  }

  function convertSize(baseSize, sizeType) {
    var normalizedSize = normalizeSize(baseSize);
    var typeMap = sizeMaps[sizeType] || sizeMaps["US(M)"];
    return typeMap[normalizedSize] || baseSize;
  }

  function getOptionName(optionElement) {
    var optionControl = optionElement.querySelector("[data-option-name]");
    if (optionControl && optionControl.dataset.optionName) return optionControl.dataset.optionName;

    var label = optionElement.querySelector(".option-label--title");
    return label ? label.textContent.replace(":", "").trim() : "";
  }

  function isSizeOption(optionElement) {
    var optionName = getOptionName(optionElement).toLowerCase();
    return optionName.indexOf("size") !== -1 && optionName.indexOf("size type") === -1 && optionName.indexOf("sizetype") === -1;
  }

  function getSizeOptionElements(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll(".m-product-option")).filter(function (optionElement) {
      return !optionElement.hasAttribute("data-jerseerium-size-type") && isSizeOption(optionElement);
    });
  }

  function createSizeGuideButton() {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "foxkit-sizechart-button m:inline-flex m:items-center m:hidden";
    button.setAttribute("data-open-sizeguide", "");

    var label = document.createElement("span");
    label.className = "foxkit-sizechart-button--label";
    label.textContent = "Size guide";
    button.appendChild(label);

    return button;
  }

  function shouldUseVisualViewportModal() {
    return window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
  }

  function applyVisualViewportFrame(modal) {
    if (!modal) return;
    if (!shouldUseVisualViewportModal()) {
      clearVisualViewportFrame(modal);
      return;
    }

    var viewport = window.visualViewport;
    var top = window.scrollY + (viewport ? viewport.offsetTop : 0);
    var left = window.scrollX + (viewport ? viewport.offsetLeft : 0);
    var width = viewport ? viewport.width : window.innerWidth;
    var height = viewport ? viewport.height : window.innerHeight;

    modal.style.position = "absolute";
    modal.style.inset = "auto";
    modal.style.top = Math.max(top, 0) + "px";
    modal.style.left = Math.max(left, 0) + "px";
    modal.style.width = Math.max(width, 0) + "px";
    modal.style.height = Math.max(height, 0) + "px";
    modal.style.minHeight = Math.max(height, 0) + "px";
  }

  function clearVisualViewportFrame(modal) {
    if (!modal) return;
    modal.style.removeProperty("position");
    modal.style.removeProperty("inset");
    modal.style.removeProperty("top");
    modal.style.removeProperty("left");
    modal.style.removeProperty("width");
    modal.style.removeProperty("height");
    modal.style.removeProperty("min-height");
  }

  function bindVisualViewportFrame(modal) {
    if (!modal) return;
    if (modal.jerseeriumVisualViewportFrame) unbindVisualViewportFrame(modal);

    var updateFrame = function () {
      applyVisualViewportFrame(modal);
    };

    modal.jerseeriumVisualViewportFrame = updateFrame;
    updateFrame();
    window.addEventListener("resize", updateFrame);
    window.addEventListener("orientationchange", updateFrame);
    window.addEventListener("scroll", updateFrame, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", updateFrame);
      window.visualViewport.addEventListener("scroll", updateFrame);
    }
    window.requestAnimationFrame(updateFrame);
  }

  function unbindVisualViewportFrame(modal) {
    if (!modal || !modal.jerseeriumVisualViewportFrame) {
      clearVisualViewportFrame(modal);
      return;
    }

    var updateFrame = modal.jerseeriumVisualViewportFrame;
    window.removeEventListener("resize", updateFrame);
    window.removeEventListener("orientationchange", updateFrame);
    window.removeEventListener("scroll", updateFrame);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", updateFrame);
      window.visualViewport.removeEventListener("scroll", updateFrame);
    }
    modal.jerseeriumVisualViewportFrame = null;
    clearVisualViewportFrame(modal);
  }

  function createSizeTypePicker(formId) {
    var row = document.createElement("div");
    row.className = "m-product-option m-product-option--button jerseerium-new-pdp-size-type";
    row.setAttribute("data-jerseerium-size-type", "");

    var labelWrapper = document.createElement("div");
    labelWrapper.className = "m-product-option--label";

    var label = document.createElement("label");
    label.className = "option-label";

    var title = document.createElement("span");
    title.className = "option-label--title";
    title.textContent = "Size Type:";

    label.appendChild(title);
    labelWrapper.appendChild(label);
    labelWrapper.appendChild(createSizeGuideButton());
    row.appendChild(labelWrapper);

    var content = document.createElement("div");
    content.className = "jerseerium-new-pdp-size-type__content";

    var input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[Size Type]";
    input.value = "US(M)";
    input.setAttribute("data-jerseerium-size-type-input", "");
    if (formId) input.setAttribute("form", formId);
    content.appendChild(input);

    ["US(M)", "US(W)", "EU", "UK"].forEach(function (sizeType, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "jerseerium-new-pdp-size-type__button";
      button.dataset.jerseeriumSizeTypeValue = sizeType;
      button.setAttribute("aria-pressed", index === 0 ? "true" : "false");
      button.textContent = sizeType;
      content.appendChild(button);
    });

    row.appendChild(content);
    return row;
  }

  function ensureSizeTypePicker(scope) {
    if (scope.dataset.jerseeriumSizeTypeEnabled === "false") return;

    var sizeOptions = getSizeOptionElements(scope);
    sizeOptions.forEach(function (sizeOption) {
      sizeOption.classList.add("jerseerium-new-pdp-size-option");
    });

    if (scope.querySelector("[data-jerseerium-size-type]") || !sizeOptions.length) return;

    var firstSizeOption = sizeOptions[0];
    var formField = firstSizeOption.querySelector("[form]");
    var formId = formField ? formField.getAttribute("form") : "";
    firstSizeOption.parentNode.insertBefore(createSizeTypePicker(formId), firstSizeOption);
  }

  function getSizeTargets(scope) {
    var sizeOptions = Array.prototype.slice.call(scope.querySelectorAll(".jerseerium-new-pdp-size-option"));
    if (!sizeOptions.length) return [];

    return sizeOptions.reduce(function (targets, sizeOption) {
      return targets.concat(
        Array.prototype.slice.call(
          sizeOption.querySelectorAll(".m-product-option--node__label, select option:not([disabled])")
        )
      );
    }, []);
  }

  function updateSizeLabels(scope, sizeType) {
    getSizeTargets(scope).forEach(function (target) {
      if (!target.dataset.jerseeriumBaseSize) {
        target.dataset.jerseeriumBaseSize = target.textContent.trim();
      }

      target.textContent = convertSize(target.dataset.jerseeriumBaseSize, sizeType);
    });
  }

  function initSizeTypePicker(picker) {
    if (picker.dataset.jerseeriumSizeTypeReady === "true") return;
    picker.dataset.jerseeriumSizeTypeReady = "true";

    var scope = picker.closest(".m-product-info--wrapper") || document;
    var buttons = Array.prototype.slice.call(picker.querySelectorAll("[data-jerseerium-size-type-value]"));
    var input = picker.querySelector("[data-jerseerium-size-type-input]");

    function setSizeType(sizeType) {
      buttons.forEach(function (button) {
        button.setAttribute("aria-pressed", button.dataset.jerseeriumSizeTypeValue === sizeType ? "true" : "false");
      });

      if (input) input.value = sizeType;
      updateSizeLabels(scope, sizeType);
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        setSizeType(button.dataset.jerseeriumSizeTypeValue);
      });
    });

    var activeButton = buttons.find(function (button) {
      return button.getAttribute("aria-pressed") === "true";
    });

    setSizeType(activeButton ? activeButton.dataset.jerseeriumSizeTypeValue : "US(M)");
  }

  function initSizeGuideTrigger(trigger) {
    if (trigger.dataset.jerseeriumSizeGuideReady === "true") return;

    var modalId = trigger.getAttribute("aria-controls");
    var modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    trigger.dataset.jerseeriumSizeGuideReady = "true";
    var modalPlaceholder = document.createComment("jerseerium size guide modal");
    var modalParent = modal.parentNode;

    function mountModal() {
      if (!modalParent || modal.parentNode === document.body) return;

      if (!modalPlaceholder.parentNode) {
        modalParent.insertBefore(modalPlaceholder, modal);
      }
      document.body.appendChild(modal);
    }

    function restoreModal() {
      if (!modalParent || !modalPlaceholder.parentNode) return;

      modalParent.insertBefore(modal, modalPlaceholder);
      modalPlaceholder.remove();
    }

    function openModal(event) {
      if (event) event.preventDefault();
      mountModal();
      modal.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      document.body.classList.add("jerseerium-size-guide-open");
      bindVisualViewportFrame(modal);

      var closeButton = modal.querySelector("[data-jerseerium-size-guide-close]");
      if (closeButton) closeButton.focus();
    }

    function closeModal(event) {
      if (event) event.preventDefault();
      modal.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      document.body.classList.remove("jerseerium-size-guide-open");
      unbindVisualViewportFrame(modal);
      restoreModal();
      trigger.focus();
    }

    trigger.addEventListener("click", openModal);

    Array.prototype.slice.call(modal.querySelectorAll("[data-jerseerium-size-guide-close]")).forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal(event);
    });

    document.addEventListener("keydown", function (event) {
      if (!modal.hidden && event.key === "Escape") closeModal(event);
    });
  }

  function parseJsonScript(script) {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn("Failed to parse multibuy JSON", error);
      return null;
    }
  }

  function getPropertyName(name) {
    var match = String(name || "").match(/^properties\[(.*)\]$/);
    return match ? match[1] : "";
  }

  function getLinePropertyFields(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[name^="properties["]'));
  }

  function getFormPropertyFields(form) {
    if (!form) return [];

    var fields = getLinePropertyFields(form);
    if (form.id) {
      fields = fields.concat(
        Array.prototype.slice.call(document.querySelectorAll('[form="' + form.id + '"][name^="properties["]'))
      );
    }

    return fields.filter(function (field, index, list) {
      return list.indexOf(field) === index;
    });
  }

  function isFileObject(value) {
    return typeof File !== "undefined" && value instanceof File;
  }

  function isUsableFile(value) {
    return isFileObject(value) && value.name && value.size > 0;
  }

  function collectPropertyEntries(fields) {
    var entries = [];

    fields.forEach(function (field) {
      if (field.disabled) return;
      if ((field.type === "checkbox" || field.type === "radio") && !field.checked) return;

      var propertyName = field.dataset.customPropertyName || getPropertyName(field.name);
      if (!propertyName) return;

      if (field.type === "file") {
        Array.prototype.slice.call(field.files || []).forEach(function (file) {
          if (!isUsableFile(file)) return;

          entries.push({
            name: propertyName,
            value: file,
            isFile: true,
            fileName: file.name,
          });
        });
        return;
      }

      var value = String(field.value || "").trim();
      if (value === "") return;

      entries.push({
        name: propertyName,
        value: value,
        isFile: false,
      });
    });

    return entries;
  }

  function entriesToProperties(entries) {
    var properties = {};

    entries.forEach(function (entry) {
      if (!entry.name) return;
      properties[entry.name] = entry.isFile ? entry.fileName : entry.value;
    });

    return properties;
  }

  function collectLinePropertyEntries(scope) {
    return collectPropertyEntries(getLinePropertyFields(scope));
  }

  function collectFormPropertyEntries(form) {
    return collectPropertyEntries(getFormPropertyFields(form));
  }

  function isNameProperty(propertyName) {
    return String(propertyName || "").toLowerCase().indexOf("name") !== -1;
  }

  function isNumberProperty(propertyName) {
    return String(propertyName || "").toLowerCase().indexOf("number") !== -1;
  }

  function shouldValidateRequiredProperty(propertyName) {
    return isNameProperty(propertyName) || isNumberProperty(propertyName);
  }

  function validateCustomPropertyFields(fields) {
    return fields.filter(function (field) {
      field.classList.remove("form-control--warning");
      if (field.disabled || field.type === "file") return false;
      if ((field.type === "checkbox" || field.type === "radio") && !field.checked) return false;

      var propertyName = field.dataset.customPropertyName || getPropertyName(field.name);
      if (!propertyName) return false;

      var value = String(field.value || "").trim();
      var invalid = false;

      if ((field.required || shouldValidateRequiredProperty(propertyName)) && !value) {
        invalid = true;
      } else if ((isNameProperty(propertyName) || isNumberProperty(propertyName)) && value.length > 20) {
        invalid = true;
      } else if (isNumberProperty(propertyName) && value && !/^\d+$/.test(value)) {
        invalid = true;
      }

      if (invalid) field.classList.add("form-control--warning");
      return invalid;
    });
  }

  function collectLineProperties(scope) {
    return entriesToProperties(collectLinePropertyEntries(scope));
  }

  function collectFormLineProperties(form) {
    return entriesToProperties(collectFormPropertyEntries(form));
  }

  function getRequiredMissing(scope) {
    return Array.prototype.slice
      .call(scope.querySelectorAll('[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])'))
      .filter(function (field) {
        field.classList.remove("form-control--warning");
        if (field.disabled) return false;
        if (field.type === "radio") {
          var selected = scope.querySelector('input[name="' + field.name + '"]:checked');
          if (!selected) {
            field.classList.add("form-control--warning");
            return true;
          }
          return false;
        }

        if (!String(field.value || "").trim()) {
          field.classList.add("form-control--warning");
          return true;
        }

        return false;
      });
  }

  function getVariantById(variants, id) {
    id = String(id || "");
    return variants.find(function (variant) {
      return String(variant.id) === id;
    });
  }

  function getCurrentProductForm(addon) {
    var formId = addon.dataset.productFormId;
    if (formId) return document.getElementById(formId);
    return document.querySelector(".m-product-form--main form");
  }

  function getCurrentVariant(addon) {
    var form = getCurrentProductForm(addon);
    var input = form ? form.querySelector('[name="id"]') : null;
    return getVariantById(addon.multibuyVariants, input ? input.value : "");
  }

  function getQuantity(form) {
    var quantityInput = form ? form.querySelector('[name="quantity"]') : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  function getVariantForSize(addon, size) {
    var sizeIndex = parseInt(addon.dataset.sizeOptionIndex, 10);
    var currentVariant = getCurrentVariant(addon);
    var variants = addon.multibuyVariants || [];

    if (isNaN(sizeIndex)) return null;

    var exactVariant = variants.find(function (variant) {
      if (!variant.options || variant.options[sizeIndex] !== size || variant.available === false) return false;
      if (!currentVariant || !currentVariant.options) return true;

      return variant.options.every(function (optionValue, index) {
        return index === sizeIndex || optionValue === currentVariant.options[index];
      });
    });

    if (exactVariant) return exactVariant;

    return variants.find(function (variant) {
      return variant.options && variant.options[sizeIndex] === size && variant.available !== false;
    });
  }

  function formatMultibuyMoney(addon, cents) {
    if (typeof formatMoney === "function") {
      return formatMoney(Math.round(cents), addon.dataset.moneyFormat);
    }

    return "$" + (Math.round(cents) / 100).toFixed(2);
  }

  function getMultibuySavings(cents, percent) {
    return Math.round(cents * (percent / 100));
  }

  function showMultibuyNotification(target, type, message) {
    if (window.MinimogTheme && MinimogTheme.Notification && typeof MinimogTheme.Notification.show === "function") {
      MinimogTheme.Notification.show({
        target: target || document.body,
        method: "appendChild",
        type: type,
        message: message,
        last: 3000,
        sticky: !target,
      });
    }
  }

  function initMultibuyAddon(addon) {
    if (addon.dataset.multibuyReady === "true") return;
    addon.dataset.multibuyReady = "true";

    addon.multibuyVariants = parseJsonScript(addon.querySelector("[data-multibuy-variants]")) || [];
    addon.multibuyRowIndex = 0;
    addon.multibuyLastSavings = 0;

    var toggle = addon.querySelector("[data-multibuy-toggle]");
    var panel = addon.querySelector("[data-multibuy-panel]");
    var rowsContainer = addon.querySelector("[data-multibuy-rows]");
    var rowTemplate = addon.querySelector("[data-multibuy-row-template]");
    var addRowButton = addon.querySelector("[data-multibuy-add-row]");
    var expressNote = addon.querySelector("[data-multibuy-express-note]");
    var review = addon.querySelector("[data-multibuy-review]");
    var reviewTitle = addon.querySelector("[data-multibuy-review-title]");
    var reviewList = addon.querySelector("[data-multibuy-review-list]");
    var messageNode = addon.querySelector("[data-multibuy-message]");
    var subtotalNode = addon.querySelector("[data-multibuy-subtotal]");
    var savingsAmountNode = addon.querySelector("[data-mb-savings-amount]");
    var savingsHintNode = addon.querySelector("[data-mb-savings-hint]");
    var ladderFill = addon.querySelector("[data-mb-ladder-fill]");
    var ladderNodes = Array.prototype.slice.call(addon.querySelectorAll("[data-mb-ladder-node]"));
    var confirmModal = addon.querySelector("[data-multibuy-confirm-modal]");
    var confirmDialog = confirmModal ? confirmModal.querySelector(".jerseerium-multibuy-confirm__dialog") : null;
    var confirmList = addon.querySelector("[data-multibuy-confirm-list]");
    var confirmSubmitButton = addon.querySelector("[data-multibuy-confirm-submit]");
    var confirmMessage = addon.querySelector("[data-multibuy-confirm-message]");
    var confirmModalPlaceholder = confirmModal ? document.createComment("jerseerium multibuy confirm modal") : null;
    var confirmModalParent = confirmModal ? confirmModal.parentNode : null;
    var productForm = getCurrentProductForm(addon);
    var productFormElement = productForm ? productForm.closest("product-form") : null;
    var submitButton = productForm ? productForm.querySelector('[name="add"]') : null;
    var submitText = submitButton ? submitButton.querySelector(".m-add-to-cart--text") : null;
    var originalSubmitText = submitText ? submitText.textContent.trim() : "";
    var dynamicCheckout = productFormElement ? productFormElement.querySelector(".m-product-dynamic-checkout") : null;
    var cartDrawer = document.querySelector("m-cart-drawer");
    var productInfo = addon.closest(".m-main-product--info");
    var errorWrapper = productFormElement ? productFormElement.querySelector(".m-product-form-message") : null;

    function getRows() {
      return Array.prototype.slice.call(rowsContainer.querySelectorAll("[data-multibuy-row]"));
    }

    function getTier(totalItems) {
      var tierOneMin = parseInt(addon.dataset.tierOneMin, 10) || 2;
      var tierOnePercent = parseInt(addon.dataset.tierOnePercent, 10) || 10;
      var tierTwoMin = parseInt(addon.dataset.tierTwoMin, 10) || 3;
      var tierTwoPercent = parseInt(addon.dataset.tierTwoPercent, 10) || 12;
      var tierThreeMin = parseInt(addon.dataset.tierThreeMin, 10) || 5;
      var tierThreePercent = parseInt(addon.dataset.tierThreePercent, 10) || 15;

      if (totalItems >= tierThreeMin) return { min: tierThreeMin, percent: tierThreePercent, key: "three" };
      if (totalItems >= tierTwoMin) return { min: tierTwoMin, percent: tierTwoPercent, key: "two" };
      if (totalItems >= tierOneMin) return { min: tierOneMin, percent: tierOnePercent, key: "one" };
      return { min: 0, percent: 0, key: "" };
    }

    function getTierSettings() {
      return {
        oneMin: parseInt(addon.dataset.tierOneMin, 10) || 2,
        onePercent: parseInt(addon.dataset.tierOnePercent, 10) || 10,
        twoMin: parseInt(addon.dataset.tierTwoMin, 10) || 3,
        twoPercent: parseInt(addon.dataset.tierTwoPercent, 10) || 12,
        threeMin: parseInt(addon.dataset.tierThreeMin, 10) || 5,
        threePercent: parseInt(addon.dataset.tierThreePercent, 10) || 15,
      };
    }

    function getJerseyNoun(count) {
      return count === 1 ? "jersey" : "jerseys";
    }

    function getTotalState() {
      var rows = getRows();
      var currentVariant = getCurrentVariant(addon);
      var quantity = getQuantity(productForm);
      var totalItems = quantity;
      var totalCents = currentVariant ? currentVariant.price * quantity : 0;

      rows.forEach(function (row) {
        var sizeSelect = row.querySelector("[data-multibuy-size]");
        var rowVariant = sizeSelect ? getVariantForSize(addon, sizeSelect.value) : null;
        totalItems += 1;
        if (rowVariant) totalCents += rowVariant.price;
      });

      var tier = getTier(totalItems);
      var savings = getMultibuySavings(totalCents, tier.percent);
      return {
        rows: rows,
        totalItems: totalItems,
        totalCents: totalCents,
        tier: tier,
        savings: savings,
      };
    }

    function updateTierPills(tier) {
      var currentVariant = getCurrentVariant(addon);
      var currentPrice = currentVariant ? currentVariant.price : 0;
      var tierOneMin = parseInt(addon.dataset.tierOneMin, 10) || 2;
      var tierOnePercent = parseInt(addon.dataset.tierOnePercent, 10) || 10;
      var tierTwoMin = parseInt(addon.dataset.tierTwoMin, 10) || 3;
      var tierTwoPercent = parseInt(addon.dataset.tierTwoPercent, 10) || 12;
      var tierThreeMin = parseInt(addon.dataset.tierThreeMin, 10) || 5;
      var tierThreePercent = parseInt(addon.dataset.tierThreePercent, 10) || 15;
      var tierOneSavings = formatMultibuyMoney(addon, getMultibuySavings(currentPrice * tierOneMin, tierOnePercent));
      var tierTwoSavings = formatMultibuyMoney(addon, getMultibuySavings(currentPrice * tierTwoMin, tierTwoPercent));
      var tierThreeSavings = formatMultibuyMoney(addon, getMultibuySavings(currentPrice * tierThreeMin, tierThreePercent));
      var summaryTitle = addon.querySelector("[data-multibuy-summary-title]");
      var summaryTitleTemplate = addon.dataset.summaryTitleTemplate || "";

      if (summaryTitle && summaryTitleTemplate) {
        summaryTitle.textContent = summaryTitleTemplate
          .replace(/\{\{\s*save_2\s*\}\}/g, tierOneSavings)
          .replace(/\{\{\s*save_3\s*\}\}/g, tierTwoSavings)
          .replace(/\{\{\s*save_5\s*\}\}/g, tierThreeSavings)
          .replace(/\[\[\s*save_2\s*\]\]/g, tierOneSavings)
          .replace(/\[\[\s*save_3\s*\]\]/g, tierTwoSavings)
          .replace(/\[\[\s*save_5\s*\]\]/g, tierThreeSavings);
      }

      Array.prototype.slice.call(addon.querySelectorAll("[data-multibuy-tier]")).forEach(function (pill) {
        pill.classList.toggle("is-active", pill.dataset.multibuyTier === tier.key);
        if (pill.dataset.multibuyTier === "one") {
          pill.textContent = tierOneMin + " jerseys - Save " + tierOneSavings;
        } else if (pill.dataset.multibuyTier === "two") {
          pill.textContent = tierTwoMin + " jerseys - Save " + tierTwoSavings;
        } else if (pill.dataset.multibuyTier === "three") {
          pill.textContent = tierThreeMin + "+ jerseys - Save " + tierThreeSavings;
        }
      });

      Array.prototype.slice.call(addon.querySelectorAll("[data-mb-ladder-tier]")).forEach(function (node) {
        var caption = node.querySelector(".jerseerium-multibuy__ladder-cap");
        if (!caption) return;

        if (node.dataset.mbLadderTier === "one") {
          caption.textContent = "Save " + tierOneSavings;
        } else if (node.dataset.mbLadderTier === "two") {
          caption.textContent = "Save " + tierTwoSavings;
        } else if (node.dataset.mbLadderTier === "three") {
          caption.textContent = "Save " + tierThreeSavings;
        }
      });
    }

    function getNextTierPrompt(state) {
      var settings = getTierSettings();
      var currentVariant = getCurrentVariant(addon);
      var nextItemPrice = currentVariant ? currentVariant.price : 0;
      var tiers = [
        { min: settings.oneMin, percent: settings.onePercent },
        { min: settings.twoMin, percent: settings.twoPercent },
        { min: settings.threeMin, percent: settings.threePercent },
      ];

      for (var index = 0; index < tiers.length; index += 1) {
        var tier = tiers[index];
        if (state.totalItems < tier.min) {
          var itemsNeeded = tier.min - state.totalItems;
          var nextTotalCents = state.totalCents + nextItemPrice * itemsNeeded;
          var nextTierSavings = getMultibuySavings(nextTotalCents, tier.percent);
          var savingsAmount = state.savings > 0 ? Math.max(nextTierSavings - state.savings, 0) : nextTierSavings;
          var formattedSavings = formatMultibuyMoney(addon, savingsAmount);
          var itemPhrase = itemsNeeded + " more " + getJerseyNoun(itemsNeeded);
          var suffix = state.savings > 0 ? " extra" : "";

          return {
            text: "Add " + itemPhrase + " to save " + formattedSavings + suffix,
            html: "Add <b>" + itemPhrase + "</b> to save " + formattedSavings + suffix,
            isBest: false,
          };
        }
      }

      return {
        text: "Best value unlocked - you're saving " + formatMultibuyMoney(addon, state.savings),
        html: "Best value unlocked - you're saving <b>" + formatMultibuyMoney(addon, state.savings) + "</b>",
        isBest: true,
      };
    }

    function getLadderProgress(totalItems, steps) {
      if (!steps.length || totalItems <= steps[0]) return 0;

      for (var index = 0; index < steps.length - 1; index += 1) {
        var currentStep = steps[index];
        var nextStep = steps[index + 1];

        if (totalItems < nextStep) {
          var segmentProgress = (totalItems - currentStep) / (nextStep - currentStep);
          return ((index + segmentProgress) / (steps.length - 1)) * 100;
        }
      }

      return 100;
    }

    function updateLadder(state) {
      if (!ladderNodes.length) return;

      var steps = ladderNodes
        .map(function (node) {
          return parseInt(node.dataset.mbLadderStep || node.dataset.step, 10);
        })
        .filter(function (step) {
          return !isNaN(step);
        });
      var activeStep = steps[0] || 1;

      steps.forEach(function (step) {
        if (state.totalItems >= step) activeStep = step;
      });

      ladderNodes.forEach(function (node) {
        var step = parseInt(node.dataset.mbLadderStep || node.dataset.step, 10);
        var isReached = !isNaN(step) && state.totalItems >= step;
        node.classList.toggle("is-reached", isReached);
        node.classList.toggle("is-current", step === activeStep);
      });

      if (ladderFill) {
        ladderFill.style.width = Math.max(0, Math.min(100, getLadderProgress(state.totalItems, steps))) + "%";
      }
    }

    function updateSavingsHero(state) {
      var prompt = getNextTierPrompt(state);

      if (savingsAmountNode) {
        savingsAmountNode.textContent = formatMultibuyMoney(addon, state.savings);
      }

      if (savingsHintNode) {
        savingsHintNode.innerHTML = prompt.html;
      }

      return prompt;
    }

    function updateDynamicCheckout(rowsCount) {
      var isActive = rowsCount > 0;
      if (dynamicCheckout) {
        if (isActive) {
          dynamicCheckout.hidden = true;
          dynamicCheckout.setAttribute("data-multibuy-hidden", "true");
        } else if (dynamicCheckout.getAttribute("data-multibuy-hidden") === "true") {
          dynamicCheckout.hidden = false;
          dynamicCheckout.removeAttribute("data-multibuy-hidden");
        }
      }

      if (expressNote) {
        expressNote.hidden = !isActive;
      }
    }

    function updateSubmitText(state, isActive) {
      if (!submitText) return;

      if (!isActive) {
        submitText.textContent = originalSubmitText || submitButton.getAttribute("data-atc-text") || "Add to cart";
        return;
      }

      var noun = state.totalItems === 1 ? "jersey" : "jerseys";
      var label = "Add " + state.totalItems + " " + noun;
      if (state.savings > 0) label += " - Save " + formatMultibuyMoney(addon, state.savings);
      submitText.textContent = label;
    }

    function getReadableProperties(properties) {
      return Object.keys(properties || {})
        .filter(function (propertyName) {
          return propertyName && propertyName.charAt(0) !== "_";
        })
        .map(function (propertyName) {
          return {
            label: propertyName,
            value: properties[propertyName],
          };
        });
    }

    function getLineSummaries(state) {
      var sizeIndex = parseInt(addon.dataset.sizeOptionIndex, 10);
      var currentVariant = getCurrentVariant(addon);
      var mainSize = currentVariant && currentVariant.options && !isNaN(sizeIndex) ? currentVariant.options[sizeIndex] : "";
      var mainQuantity = getQuantity(productForm);
      var mainProperties = collectFormLineProperties(productForm);
      var lines = [
        {
          label: "Jersey 1",
          quantity: mainQuantity,
          size: mainSize,
          properties: getReadableProperties(mainProperties),
        },
      ];

      state.rows.forEach(function (row, index) {
        var sizeSelect = row.querySelector("[data-multibuy-size]");
        var properties = collectLineProperties(row);
        var sizeTypeInput = productInfo ? productInfo.querySelector("[data-jerseerium-size-type-input]") : null;

        if (sizeTypeInput && sizeTypeInput.value && !properties["Size Type"]) {
          properties["Size Type"] = sizeTypeInput.value;
        }

        lines.push({
          label: "Jersey " + (index + 2),
          quantity: 1,
          size: sizeSelect ? sizeSelect.value : "",
          properties: getReadableProperties(properties),
        });
      });

      return lines;
    }

    function getLineReviewParts(line) {
      var parts = ["Size: " + (line.size || "not set")];
      var detailEntries = line.properties.filter(function (entry) {
        return entry.label !== "Size Type";
      });

      if (detailEntries.length > 0) {
        parts.push(
          "Details: " +
            detailEntries
              .map(function (entry) {
                return entry.label + ": " + (entry.value || "not set");
              })
              .join(", ")
        );
      } else {
        parts.push("Details: not set");
      }

      return parts;
    }

    function renderReview(state, isActive) {
      if (!review || !reviewTitle || !reviewList) return;

      review.hidden = !isActive;
      if (!isActive) {
        reviewList.innerHTML = "";
        reviewTitle.textContent = "";
        return;
      }

      var lines = getLineSummaries(state);

      reviewTitle.textContent =
        "You're adding " +
        state.totalItems +
        " jerseys - please check each size and custom detail. Custom orders can't be changed after checkout.";
      reviewList.innerHTML = "";
      lines.forEach(function (line) {
        var item = document.createElement("li");
        item.textContent = line.label + " - " + getLineReviewParts(line).join(" / ");
        reviewList.appendChild(item);
      });
    }

    function createConfirmDetail(label, value) {
      var row = document.createElement("div");
      var labelNode = document.createElement("span");
      var valueNode = document.createElement("span");

      row.className = "jerseerium-multibuy-confirm__detail";
      labelNode.className = "jerseerium-multibuy-confirm__detail-label";
      valueNode.className = "jerseerium-multibuy-confirm__detail-value";
      labelNode.textContent = label;
      valueNode.textContent = value || "Not set";
      row.appendChild(labelNode);
      row.appendChild(valueNode);

      return row;
    }

    function setConfirmLoading(isLoading) {
      addon.multibuyConfirming = isLoading;
      if (confirmSubmitButton) {
        confirmSubmitButton.disabled = isLoading;
        confirmSubmitButton.textContent = isLoading ? "Adding..." : "Confirm & add to cart";
      }
    }

    function renderConfirmList(state) {
      if (!confirmList) return;

      var lines = getLineSummaries(state);
      confirmList.innerHTML = "";

      lines.forEach(function (line) {
        var card = document.createElement("article");
        var header = document.createElement("div");
        var title = document.createElement("h3");
        var quantity = document.createElement("span");
        var details = document.createElement("div");

        card.className = "jerseerium-multibuy-confirm__item";
        header.className = "jerseerium-multibuy-confirm__item-header";
        title.className = "jerseerium-multibuy-confirm__item-title";
        quantity.className = "jerseerium-multibuy-confirm__item-qty";
        details.className = "jerseerium-multibuy-confirm__details";

        title.textContent = line.label;
        quantity.textContent = line.quantity > 1 ? "Qty " + line.quantity : "Qty 1";
        header.appendChild(title);
        header.appendChild(quantity);

        details.appendChild(createConfirmDetail("Size", line.size));
        line.properties.forEach(function (entry) {
          details.appendChild(createConfirmDetail(entry.label, entry.value));
        });

        card.appendChild(header);
        card.appendChild(details);
        confirmList.appendChild(card);
      });
    }

    function mountConfirmModal() {
      if (!confirmModal || !confirmModalParent || confirmModal.parentNode === document.body) return;

      if (confirmModalPlaceholder && !confirmModalPlaceholder.parentNode) {
        confirmModalParent.insertBefore(confirmModalPlaceholder, confirmModal);
      }
      document.body.appendChild(confirmModal);
    }

    function restoreConfirmModal() {
      if (!confirmModal || !confirmModalParent || !confirmModalPlaceholder || !confirmModalPlaceholder.parentNode) return;

      confirmModalParent.insertBefore(confirmModal, confirmModalPlaceholder);
      confirmModalPlaceholder.remove();
    }

    function openConfirmModal(items, state) {
      if (!confirmModal) return false;

      addon.multibuyPendingItems = items;
      addon.multibuyLastFocus = document.activeElement;
      setConfirmLoading(false);
      renderConfirmList(state);
      if (confirmMessage) confirmMessage.textContent = "";
      mountConfirmModal();
      confirmModal.hidden = false;
      document.body.classList.add("jerseerium-multibuy-confirm-open");
      bindVisualViewportFrame(confirmModal);

      if (confirmDialog) {
        if (!confirmDialog.hasAttribute("tabindex")) confirmDialog.setAttribute("tabindex", "-1");
        confirmModal.scrollTop = 0;
        confirmDialog.scrollTop = 0;

        try {
          confirmDialog.focus({ preventScroll: true });
        } catch (error) {
          confirmDialog.focus();
        }

        window.requestAnimationFrame(function () {
          confirmModal.scrollTop = 0;
          confirmDialog.scrollTop = 0;
        });
      }
      return true;
    }

    function closeConfirmModal(event) {
      if (event) event.preventDefault();
      if (!confirmModal || addon.multibuyConfirming) return;

      confirmModal.hidden = true;
      document.body.classList.remove("jerseerium-multibuy-confirm-open");
      addon.multibuyPendingItems = null;
      if (confirmMessage) confirmMessage.textContent = "";
      unbindVisualViewportFrame(confirmModal);
      restoreConfirmModal();

      if (addon.multibuyLastFocus && typeof addon.multibuyLastFocus.focus === "function") {
        addon.multibuyLastFocus.focus();
      }
    }

    function updateStatus() {
      var state = getTotalState();
      var isActive = !panel.hidden && state.rows.length > 0;
      var prompt;

      updateTierPills(state.tier);
      updateLadder(state);
      prompt = updateSavingsHero(state);
      updateDynamicCheckout(isActive ? state.rows.length : 0);
      updateSubmitText(state, isActive);
      renderReview(state, isActive);

      addon.multibuyLastSavings = state.savings;
      if (messageNode) messageNode.textContent = prompt ? prompt.text : "";
      if (subtotalNode) {
        var discountedTotal = Math.max(state.totalCents - state.savings, 0);
        subtotalNode.textContent =
          "Subtotal " +
          formatMultibuyMoney(addon, discountedTotal) +
          (state.savings > 0 ? " - You save " + formatMultibuyMoney(addon, state.savings) : "");
      }
    }

    function addRow() {
      if (!rowTemplate) return;

      addon.multibuyRowIndex += 1;
      var rowHtml = rowTemplate.innerHTML.replace(/__INDEX__/g, String(addon.multibuyRowIndex));
      var wrapper = document.createElement("div");
      wrapper.innerHTML = rowHtml.trim();
      var row = wrapper.firstElementChild;
      var currentVariant = getCurrentVariant(addon);
      var sizeIndex = parseInt(addon.dataset.sizeOptionIndex, 10);
      var sizeSelect = row.querySelector("[data-multibuy-size]");

      if (sizeSelect && currentVariant && currentVariant.options && currentVariant.options[sizeIndex]) {
        sizeSelect.value = currentVariant.options[sizeIndex];
      }

      rowsContainer.appendChild(row);
      refreshRows();
      updateStatus();
    }

    function refreshRows() {
      getRows().forEach(function (row, index) {
        var numberNode = row.querySelector("[data-multibuy-row-number]");
        if (numberNode) numberNode.textContent = String(index + 1);
      });
    }

    function removeRow(row) {
      row.remove();
      refreshRows();
      updateStatus();
    }

    function openPanel() {
      if (!panel.hidden) return;
      panel.hidden = false;
      toggle.setAttribute("aria-expanded", "true");
      if (getRows().length === 0) addRow();
      updateStatus();
    }

    function closePanel() {
      panel.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      updateStatus();
    }

    function openSizeGuide(event) {
      event.preventDefault();
      var modalId = addon.dataset.sizeGuideModalId;
      var trigger = modalId
        ? document.querySelector('[data-jerseerium-size-guide-trigger][aria-controls="' + modalId + '"]')
        : null;

      if (!trigger) trigger = document.querySelector("[data-open-sizeguide]");
      if (trigger) trigger.click();
    }

    function validateMultibuyRows() {
      var missing = [];
      getRows().forEach(function (row) {
        var sizeSelect = row.querySelector("[data-multibuy-size]");
        var rowMissing = [];
        row.classList.remove("is-invalid");

        if (sizeSelect) sizeSelect.classList.remove("form-control--warning");
        if (!sizeSelect || !sizeSelect.value || !getVariantForSize(addon, sizeSelect.value)) {
          if (sizeSelect) sizeSelect.classList.add("form-control--warning");
          rowMissing.push(sizeSelect || row);
        }

        rowMissing = rowMissing.concat(getRequiredMissing(row));
        rowMissing = rowMissing.concat(validateCustomPropertyFields(getLinePropertyFields(row)));
        if (rowMissing.length > 0) row.classList.add("is-invalid");
        missing = missing.concat(rowMissing);
      });

      return missing;
    }

    function validateMainCustomizationFields() {
      return validateCustomPropertyFields(getFormPropertyFields(productForm));
    }

    function buildItems() {
      var formData = new FormData(productForm);
      var mainVariantId = formData.get("id");
      var mainQuantity = getQuantity(productForm);
      var mainPropertyEntries = collectFormPropertyEntries(productForm);
      var items = [
        {
          id: Number(mainVariantId),
          quantity: mainQuantity,
          properties: entriesToProperties(mainPropertyEntries),
          propertyEntries: mainPropertyEntries,
        },
      ];

      getRows().forEach(function (row) {
        var sizeSelect = row.querySelector("[data-multibuy-size]");
        var rowVariant = sizeSelect ? getVariantForSize(addon, sizeSelect.value) : null;
        var propertyEntries = collectLinePropertyEntries(row);
        var properties = entriesToProperties(propertyEntries);
        var sizeTypeInput = productInfo ? productInfo.querySelector("[data-jerseerium-size-type-input]") : null;

        if (sizeTypeInput && sizeTypeInput.value && !properties["Size Type"]) {
          properties["Size Type"] = sizeTypeInput.value;
          propertyEntries.push({
            name: "Size Type",
            value: sizeTypeInput.value,
            isFile: false,
          });
        }

        if (rowVariant) {
          items.push({
            id: Number(rowVariant.id),
            quantity: 1,
            properties: properties,
            propertyEntries: propertyEntries,
          });
        }
      });

      return items;
    }

    function setLoading(isLoading) {
      if (productFormElement) productFormElement.classList.toggle("m-spinner-loading", isLoading);
      if (submitButton) submitButton.disabled = isLoading;
    }

    function emitAdded(response) {
      document.dispatchEvent(
        new CustomEvent("product-ajax:added", {
          detail: {
            product: response,
            products: response && response.items ? response.items : [],
          },
        })
      );

      if (window.MinimogEvents && window.MinimogTheme) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, response);
      }
    }

    function getCartUrl() {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
      var cartRoute = window.MinimogSettings && MinimogSettings.routes ? MinimogSettings.routes.cart : "";
      return cartRoute || root.replace(/\/?$/, "/") + "cart";
    }

    function waitForTracking() {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, 400);
      });
    }

    function redirectToCart(response) {
      emitAdded(response);

      return waitForTracking().then(function () {
        window.location.href = getCartUrl();
      });
    }

    function getCartAddAjaxUrl() {
      var route = window.MinimogSettings && MinimogSettings.routes ? MinimogSettings.routes.cart_add_url : null;
      if (!route) return "/cart/add.js";
      return route.slice(-3) === ".js" ? route : route.replace(/\/cart\/add$/, "/cart/add.js");
    }

    function getCartItemForJson(item) {
      return {
        id: item.id,
        quantity: item.quantity,
        properties: item.properties || {},
      };
    }

    function hasFileProperties(items) {
      return items.some(function (item) {
        return (item.propertyEntries || []).some(function (entry) {
          return entry.isFile && isUsableFile(entry.value);
        });
      });
    }

    function appendItemProperties(formData, item) {
      var entries = item.propertyEntries || [];

      if (entries.length > 0) {
        entries.forEach(function (entry) {
          if (!entry.name) return;
          var propertyFieldName = "properties[" + entry.name + "]";

          if (entry.isFile) {
            if (isUsableFile(entry.value)) {
              formData.append(propertyFieldName, entry.value, entry.fileName || entry.value.name);
            }
            return;
          }

          if (String(entry.value || "").trim() !== "") {
            formData.append(propertyFieldName, entry.value);
          }
        });
        return;
      }

      Object.keys(item.properties || {}).forEach(function (propertyName) {
        var value = item.properties[propertyName];
        if (String(value || "").trim() !== "") {
          formData.append("properties[" + propertyName + "]", value);
        }
      });
    }

    function getFormDataFetchConfig() {
      var config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      return config;
    }

    function addCartItemWithFormData(item, includeSections) {
      var config = getFormDataFetchConfig();
      var formData = new FormData();

      formData.append("id", item.id);
      formData.append("quantity", item.quantity);
      appendItemProperties(formData, item);

      if (includeSections && cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cartDrawer.getSectionsToRender().map(function (section) {
            return section.id;
          })
        );
        formData.append("sections_url", window.location.pathname);
      }

      config.body = formData;

      return fetch(getCartAddAjaxUrl(), config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) return Promise.reject(response);
          return response;
        });
    }

    function addMultibuyItemsWithFormData(items) {
      var responses = [];
      var chain = Promise.resolve();

      items.forEach(function (item, index) {
        chain = chain.then(function () {
          return addCartItemWithFormData(item, index === items.length - 1).then(function (response) {
            responses.push(response);
          });
        });
      });

      return chain.then(function () {
        return {
          items: responses,
        };
      });
    }

    function addMultibuyItems(items) {
      var config = fetchConfig();
      var body = {
        items: items.map(getCartItemForJson),
        sections_url: window.location.pathname,
      };

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
        body.sections = cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        });
      }

      config.body = JSON.stringify(body);
      setLoading(true);
      setConfirmLoading(true);
      if (confirmMessage) confirmMessage.textContent = "Adding your jerseys...";

      if (hasFileProperties(items)) {
        return addMultibuyItemsWithFormData(items)
          .then(function (response) {
            return redirectToCart(response);
          })
          .catch(function (error) {
            var message = error && (error.description || error.message)
              ? error.description || error.message
              : window.MinimogStrings
                ? MinimogStrings.cartError
                : "Cart error";
            console.error(error);
            if (confirmMessage) confirmMessage.textContent = message;
            showMultibuyNotification(errorWrapper, "error", message);
          })
          .finally(function () {
            setLoading(false);
            setConfirmLoading(false);
          });
      }

      return fetch(getCartAddAjaxUrl(), config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            var message = response.description || response.message;
            if (confirmMessage) confirmMessage.textContent = message;
            showMultibuyNotification(errorWrapper, "error", message);
            return;
          }

          return redirectToCart(response);
        })
        .catch(function (error) {
          console.error(error);
          if (confirmMessage) confirmMessage.textContent = window.MinimogStrings ? MinimogStrings.cartError : "Cart error";
          showMultibuyNotification(errorWrapper, "error", window.MinimogStrings ? MinimogStrings.cartError : "Cart error");
        })
        .finally(function () {
          setLoading(false);
          setConfirmLoading(false);
        });
    }

    function submitMultibuy(event) {
      if (panel.hidden || getRows().length === 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var mainMissing = typeof validateForm === "function" ? validateForm(productInfo || productForm) : [];
      if (!mainMissing) mainMissing = [];
      mainMissing = mainMissing.concat(validateMainCustomizationFields());
      var rowMissing = validateMultibuyRows();

      if (mainMissing.length || rowMissing.length) {
        showMultibuyNotification(
          errorWrapper,
          "warning",
          "Please check each size and custom detail before checkout."
        );
        return;
      }

      var items = buildItems();
      if (items.length < 2) return;

      if (openConfirmModal(items, getTotalState())) return;
      addMultibuyItems(items);
    }

    if (toggle) {
      toggle.addEventListener("click", function () {
        if (panel.hidden) {
          openPanel();
        } else {
          closePanel();
        }
      });
    }

    if (addRowButton) addRowButton.addEventListener("click", addRow);
    if (confirmModal) {
      Array.prototype.slice.call(confirmModal.querySelectorAll("[data-multibuy-confirm-close]")).forEach(function (button) {
        button.addEventListener("click", closeConfirmModal);
      });
    }
    if (confirmSubmitButton) {
      confirmSubmitButton.addEventListener("click", function (event) {
        event.preventDefault();
        if (!addon.multibuyPendingItems || addon.multibuyConfirming) return;
        addMultibuyItems(addon.multibuyPendingItems);
      });
    }

    addon.addEventListener("click", function (event) {
      var removeButton = event.target.closest("[data-multibuy-remove-row]");
      var sizeGuideButton = event.target.closest("[data-multibuy-size-guide]");

      if (removeButton) {
        event.preventDefault();
        removeRow(removeButton.closest("[data-multibuy-row]"));
      }

      if (sizeGuideButton) openSizeGuide(event);
    });

    addon.addEventListener("change", updateStatus);
    addon.addEventListener("input", updateStatus);
    if (productInfo) {
      productInfo.addEventListener("change", updateStatus);
      productInfo.addEventListener("input", updateStatus);
    }
    if (submitButton) submitButton.addEventListener("click", submitMultibuy, true);
    if (productForm) productForm.addEventListener("submit", submitMultibuy, true);
    document.addEventListener("variant:changed", updateStatus);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && confirmModal && !confirmModal.hidden) closeConfirmModal(event);
    });
    updateStatus();
  }

  function normalizeMultibuyPosition(root) {
    var scope = root || document;
    var blocks = Array.prototype.slice.call(scope.querySelectorAll(".main-product__block-multibuy_addon"));

    if (scope.nodeType === 1 && scope.classList.contains("main-product__block-multibuy_addon")) {
      blocks.unshift(scope);
    }

    blocks.forEach(function (multibuyBlock) {
      var productInfo = multibuyBlock.closest(".m-main-product--info");
      var buyButtonsBlock = productInfo ? productInfo.querySelector(".main-product__block-buy_buttons") : null;
      var productFormElement = buyButtonsBlock ? buyButtonsBlock.querySelector("product-form.m-product-form--main") : null;

      if (!buyButtonsBlock || !productFormElement) return;

      buyButtonsBlock.insertBefore(multibuyBlock, productFormElement);
    });
  }

  function initMultibuy(root) {
    normalizeMultibuyPosition(root);
    Array.prototype.slice.call((root || document).querySelectorAll("jerseerium-multibuy-addon")).forEach(initMultibuyAddon);
  }

  function init(root) {
    var isNewProductPage = document.body.classList.contains("new-product-page");

    if (isNewProductPage) {
      Array.prototype.slice.call((root || document).querySelectorAll("variant-picker")).forEach(ensureSizeTypePicker);

      Array.prototype.slice.call((root || document).querySelectorAll("[data-jerseerium-size-type]")).forEach(
        initSizeTypePicker
      );

      Array.prototype.slice.call((root || document).querySelectorAll("[data-jerseerium-size-guide-trigger]")).forEach(
        initSizeGuideTrigger
      );
    }

    initMultibuy(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
